var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-layout" },
    [
      _vm.bizDepartComList.length > 0
        ? _c(
            "el-table",
            {
              ref: "swb_hop_device_stcok_check_voucher_for_pdf",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.bizDepartComList, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { align: "left", prop: "fullName", label: "下属部门" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "state",
                  label: "当前状态",
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.orgStateMap[rows.row.state] || ""))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", label: "是否通过", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.state != _vm.closedState
                          ? _c("span", { staticClass: "font-red" }, [
                              _vm._v("未通过")
                            ])
                          : _c("span", [_vm._v("通过")])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.bizUnitComList.length > 0
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-top": "10px" },
              attrs: { data: _vm.bizUnitComList, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "fullName",
                  label: "下属业务单元"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "state",
                  label: "当前状态",
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.orgStateMap[rows.row.state] || ""))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { align: "center", label: "是否通过", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.state != _vm.closedState
                          ? _c("span", { staticClass: "font-red" }, [
                              _vm._v("未通过")
                            ])
                          : _c("span", [_vm._v("通过")])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ],
          ref: "swb_org_attr_check_dlg"
        },
        [
          _c(
            "table",
            {
              staticClass: "simple-tbl",
              staticStyle: {
                width: "100%",
                "table-layout": "fixed",
                "border-collapse": "collapse",
                "border-spacing": "2px",
                "border-color": "gray",
                color: "#666",
                "font-size": "12px",
                "word-break": "break-strict"
              }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                { staticClass: "body" },
                _vm._l(_vm.checkResultComList, function(
                  checkResutlInfo,
                  index
                ) {
                  return _c(
                    "tr",
                    { staticClass: "row" },
                    [
                      index == 0 ||
                      checkResutlInfo.id != _vm.checkResultComList[index - 1].id
                        ? [
                            _c(
                              "td",
                              {
                                staticStyle: {
                                  border: "1px solid #1a1a1a",
                                  "vertical-align": "middle",
                                  padding: "10px 4px"
                                },
                                attrs: {
                                  rowspan:
                                    checkResutlInfo.checkResultList.length
                                }
                              },
                              [
                                checkResutlInfo.orgType == 0
                                  ? _c("span", [_vm._v("业务部门")])
                                  : _c("span", [_vm._v("业务单元")])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticStyle: {
                                  border: "1px solid #1a1a1a",
                                  "vertical-align": "middle",
                                  padding: "10px 4px"
                                },
                                attrs: {
                                  rowspan:
                                    checkResutlInfo.checkResultList.length
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(checkResutlInfo.fullName || ""))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticStyle: {
                                  border: "1px solid #1a1a1a",
                                  "vertical-align": "middle",
                                  padding: "10px 4px"
                                },
                                attrs: {
                                  rowspan:
                                    checkResutlInfo.checkResultList.length
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orgStateMap[checkResutlInfo.state] ||
                                        ""
                                    )
                                  )
                                ])
                              ]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(checkResutlInfo.warnMsg || ""))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            border: "1px solid #1a1a1a",
                            "vertical-align": "middle",
                            padding: "10px 4px"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(checkResutlInfo.handleMsg || ""))
                          ])
                        ]
                      )
                    ],
                    2
                  )
                })
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row", staticStyle: { height: "40px" } }, [
        _c(
          "td",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              "text-align": "center",
              "font-size": "14px"
            }
          },
          [_vm._v("组织类型")]
        ),
        _vm._v(" "),
        _c(
          "td",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              "text-align": "center",
              "font-size": "14px"
            }
          },
          [_vm._v("部门全称")]
        ),
        _vm._v(" "),
        _c(
          "td",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              "text-align": "center",
              "font-size": "14px"
            }
          },
          [_vm._v("状态")]
        ),
        _vm._v(" "),
        _c(
          "td",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              "text-align": "center",
              "font-size": "14px"
            }
          },
          [_vm._v("未通过原因")]
        ),
        _vm._v(" "),
        _c(
          "td",
          {
            staticStyle: {
              border: "1px solid #1a1a1a",
              "vertical-align": "middle",
              padding: "10px 4px",
              "text-align": "center",
              "font-size": "14px"
            }
          },
          [_vm._v("处理方式")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52919581", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52919581","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/checkComStateList.vue
// module id = 2257
// module chunks = 0